import { Outlet } from "react-router-dom";
import { useAuth } from "../hooks/useAuth";
import { LoadingSpinner } from "../components/LoadingSpinner";
import { LandingPage } from "../pages/LandingPage";
import { hasSessionHint } from "../utils/sessionHint";

// Conditional root: guests at `/` get the marketing landing page; authenticated
// users get the app home (Outlet → AppLayout → HomePage) exactly as before.
export function RootGate() {
  const { isAuthenticated, isLoading } = useAuth();

  if (isLoading) {
    // While the silent refresh resolves: guests (no session hint) render the
    // landing instantly; returning users get a spinner instead of a landing
    // flash. See utils/sessionHint.ts.
    return hasSessionHint() ? (
      <LoadingSpinner message="Checking authentication..." />
    ) : (
      <LandingPage />
    );
  }

  if (!isAuthenticated) {
    return <LandingPage />;
  }

  return <Outlet />;
}
